// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nl-6";
export var imgContainer = "_nl-3";
export var menuIcon = "_nl-5";
export var pillWrapper = "_nl-2";
export var pillsContainer = "_nl-1";
export var subscriptionCard = "_nl-0";
export var subscriptionLogo = "_nl-4";